export default __webpack_public_path__ + "guide--raster-cyclone-debbie-960-5edadf56c4a31cd3b066992e2238f9ec.jpg";